import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto, Regulation } from "../../../../autogen/bff-api";
import { useDisplayOsloDate } from "../../../../common/formatting/useDisplayOsloDate";
import { statutoryClauses, type StandstillTerms } from "../../../sourcing-event/award/awardLetterTemplates";
import { isPrivatePortalEvent } from "./PrivateInviteCta";

interface Props {
  event: PortalSourcingEventDetailDto;
  regulation: Regulation | null;
  standstillExpiresAt?: string | null;
  standstill?: StandstillTerms;
}

export const AwardStatutoryNotices = ({ event, regulation, standstillExpiresAt, standstill }: Props) => {
  const { t } = useTranslation();
  const displayDate = useDisplayOsloDate();
  const clauses = statutoryClauses({
    eventRunsPrivateFlow: isPrivatePortalEvent(event),
    outsideProcurementAct: event.outsideProcurementAct ?? false,
    buyerRunsPublicProcurements: event.buyerRunsPublicProcurements ?? false,
    regulation,
    standstill,
    designContest: !!event.designContest,
  });
  const hasExpired = !!standstillExpiresAt && new Date(standstillExpiresAt) < new Date();

  return (
    <>
      {clauses.standstill && standstillExpiresAt && (
        <Box bg="smBackground" rounded="md" border="1px solid" borderColor="smBorder" p="3">
          <Text fontSize="sm" color="smText">
            {standstill?.exemption
              ? clauses.standstill
              : hasExpired
              ? t("The standstill period has expired")
              : t("The standstill period expires {{date}}. The contract cannot be signed before it is over.", {
                  date: displayDate(standstillExpiresAt),
                })}
          </Text>
        </Box>
      )}
      <Text fontSize="sm" color="smMuted">
        {clauses.complaint ?? t("If you have questions about the decision, contact {{buyer}}.", { buyer: event.buyerName })}
      </Text>
    </>
  );
};
